import Landing from "../../components/landing/landing.vue";
import Intro from "../../components/intro/intro.vue";
import FeaturedOutfits from "../../components/landing/featured-outfits.vue";
import FeaturedOutfitsShop from "../../components/landing/featured-outfits-shop.vue";
import FeaturedCollectionShop from "../../components/featured-collections/outfits-shop.vue";
import PurchaseOutfitContainer from "../../components/outfit/purchase-outfit-container.vue";
import { LANDING_MENU_PAGES } from "../../config.js";

export default {
    path: "/",
    component: {
        render(c) {
            return c("router-view");
        },
    },
    children: [
        {
            path: "",
            component: Landing,
            meta: {
                requiresAuth: true,
                pages: LANDING_MENU_PAGES,
            },
        },
        {
            path: "intro",
            component: Intro,
            meta: {
                headerStyle: "hidden",
                requiresAuth: false,
            },
        },
        {
            path: "featured-outfits",
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "",
                    component: FeaturedOutfits,
                    meta: {
                        requiresAuth: true,
                        pages: LANDING_MENU_PAGES,
                    },
                },
                {
                    path: "/shop",
                    component: FeaturedOutfitsShop,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: "/shop/purchase-outfit",
                    component: PurchaseOutfitContainer,
                    meta: {
                        requiresAuth: true,
                        featuredOutfit: true,
                    },
                },
                {
                    path: "/shop/featured-collections/:id",
                    component: FeaturedCollectionShop,
                    meta: {
                        requiresAuth: true,
                    },
                },
            ],
        },
    ],
};
